import React from 'react';
import './About.css';
import profile_pic from '../../assets/about/photoStanding.png'

const About = () => {
    return (
        <div id='about' className="about-container">
            <div className="left-section">
                <img src={profile_pic} alt="Your Picture" className="profile-picture" />
            </div>
            <div className="right-section">
                <h2>About Me</h2>
                <p>
                    Hello there! I'm on a mission to transform my passion for technology into impactful solutions. Currently a dedicated student, I'm eagerly seeking opportunities to dive headfirst into the world of software engineering.
                    By day, you'll find me immersed in textbooks, eager to absorb every bit of knowledge that will propel me forward. But when the sun sets, my true journey begins. Armed with a keyboard and determination, I dive into the depths of coding, turning ideas into reality, one line at a time.
                </p>
                <a href="https://firebasestorage.googleapis.com/v0/b/portfolio-pankaj-e0252.appspot.com/o/Pankaj%20-%20Current%20Resume-5.pdf?alt=media&token=a7033106-70db-4d15-a589-07b5dedeeeb1"
                    download
                    className="resume-button"
                    target="_blank" rel="noopener noreferrer">
                    Download Resume
                </a>
            </div>
        </div>
    );
}

export default About;
